export default "__VITE_ASSET__CodvZzHv__"